<template>
  <div>
    <PageTitleVue
      :sub-title="'Crie relatórios precisos de sua empresa com facilidade'"
    >
      Relatórios
    </PageTitleVue>

    <section>
      <div
        class="relative overflow-x-auto shadow-md sm:rounded-lg min-h-[25vh] p-2"
      >
        <div
          class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white"
        >
          <DropDownOptions
            v-model="selectedFilter"
            :label="'TIPO'"
            :options="['FUNCIONÁRIOS', 'ESTOQUE', 'SIS. EMERGÊNCIA']"
          />

          <DatePicker />

          <SearchInput v-model="searchTerm" />
        </div>

        <div class="w-full justify-items-center ml-auto mr-auto">
          <button
            type="button"
            class="flex text-white bg-gradient-to-r to-[#93cd24] from-[#0c7036] hover:cursor-pointer transition-all hover:scale-105 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 focus:outline-none"
          >
            <component
              class="h-5 w-5 mt-auto mb-auto mr-2 -ml-3"
              :is="PhMagnifyingGlass"
            ></component>
            Buscar
          </button>
        </div>

        <!-- funcionários -->
        <Transition mode="out-in">
          <section
            v-if="selectedFilter == 'FUNCIONÁRIOS'"
            :key="selectedFilter"
          >
            <EmployeeTable :data="filteredData">
              <template #head>
                <th scope="col" class="px-6 py-3">Nome</th>
                <th scope="col" class="px-6 py-3">EPI's pegos</th>
                <th scope="col" class="px-6 py-3">ASOS</th>
                <th scope="col" class="px-6 py-3 text-center">Treinamentos</th>
                <th scope="col" class="px-6 py-3 text-center">#</th>
              </template>
            </EmployeeTable>

            <MetricsGraph />
          </section>
        </Transition>

        <!-- estoque -->
        <Transition mode="out-in">
          <section v-if="selectedFilter == 'ESTOQUE'" :key="selectedFilter">
            <StockTable :data="filteredData">
              <template #head>
                <th scope="col" class="px-6 py-3">Nome</th>
                <th scope="col" class="px-6 py-3">CA</th>
                <th scope="col" class="px-6 py-3">Cadastrado em</th>
                <th scope="col" class="px-6 py-3 text-center">Distribuído</th>
                <th scope="col" class="px-6 py-3 text-center">#</th>
              </template>
            </StockTable>
          </section>
        </Transition>

        <!-- sis. emergência -->
        <Transition mode="out-in">
          <section
            v-if="selectedFilter == 'SIS. EMERGÊNCIA'"
            :key="selectedFilter"
          >
            <DataTable :data="filteredData">
              <template #head>
                <th scope="col" class="px-6 py-3">Nome</th>
                <th scope="col" class="px-6 py-3">Celular</th>
                <th scope="col" class="px-6 py-3">Função</th>
                <th scope="col" class="px-6 py-3 text-center">
                  Tipo de permissão
                </th>
                <th scope="col" class="px-6 py-3 text-center">#</th>
              </template>
            </DataTable>
          </section>
        </Transition>
      </div>
    </section>
  </div>
</template>

<script setup>
import DropDownOptions from "@/components/Tables/DropDownOptions.vue";
import SearchInput from "@/components/Tables/SearchInput.vue";
import PageTitleVue from "@/components/Titles/PageTitle.vue";
import ReportService from "./services/collab.service";
import DatePicker from "./components/DatePicker.vue";
import Create from "@/components/Buttons/Create.vue";
import DataTable from "./components/DataTable.vue";
import EmployeeTable from "./components/EmployeeTable.vue";
import StockTable from "./components/StockTable.vue";
import MetricsGraph from "./components/employee/metricsGraph.vue";
import router from "@/router";
import { storeApp } from "@/store";
import { onBeforeMount, ref, computed } from "vue";
import { showToast as toast } from "@/helpers/UseToasts";

import { UserPlusIcon } from "@heroicons/vue/24/outline";
import { PhMagnifyingGlass } from "@phosphor-icons/vue";

const appStore = storeApp.state;
const dataTable = ref([]);
const selectedFilter = ref("");
const searchTerm = ref("");

const filters = computed(() => {
  if (dataTable.value) {
    return [...new Set(dataTable.value.map((i) => i.permission_type))];
  }
});

const filteredData = computed(() => {
  const searchTermLower = searchTerm.value?.toLowerCase();

  return dataTable?.value?.filter((row) => {
    if (selectedFilter.value === "Todos") selectedFilter.value = "";

    const matchesDropdown =
      !selectedFilter.value || row.permission_type === selectedFilter.value;

    const matchesSearch =
      !searchTerm.value ||
      ["name", "function", "permission_type", "email", "phone"].some(
        (key) =>
          row[key] &&
          row[key].toString().toLowerCase().includes(searchTermLower)
      );

    return matchesDropdown && matchesSearch;
  });
});

onBeforeMount(async () => {
  await Promise.all([getCollaborators()]);
});

async function getCollaborators() {
  await ReportService.getAllColaborators()
    .then((res) => {
      console.log(res.data);
      dataTable.value = res.data.filter(
        (el) => el.id !== localStorage.getItem("__uuid")
      );
    })
    .catch((err) => {
      toast("Erro", "Algo deu errado ao buscar colaboradores", "error");
    });
}
</script>

<style lang="scss" scoped>
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
